import React from 'react';

import Flag from "react-flags";
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import { LocationBlue, WorkExpIcon } from '../../../../assets/images/icons';

function WorkExperience({ jobseeker, ref }) {
    const { t } = useTranslation();
    return (
        <div ref={ref} className={styles.educationContainer} id='workExperience' style={{ width: '100%', }}>
            <h2 className={styles.heading}>{t('general.UI.work_experience')}</h2>
            {
                jobseeker?.work_experiences?.map((item) => {
                    // Display "Present" for current jobs
                    const displayEndDate = item?.isCurrent ? t('forms.workExperience.present', 'Present') : item?.endDate;

                    return (
                        <div className={styles.workExperienceContainer} key={item?.id}>
                            <div className={styles.workExperienceImage}>
                                <img className={styles.workExpIcon} src={WorkExpIcon} />
                            </div>
                            <div className={styles.workExperienceBody}>
                                <div className={styles.workExperienceBodyHeader}>
                                    <div className={styles.workdExpTitleAndDesc}>
                                        <h2 className={styles.heading}>{item?.position}</h2>
                                        <p className={`${styles.description} ${styles.educationDescription}`} >
                                            {item?.company}</p>
                                    </div>
                                    <div className={styles.workdExpYear}>
                                        <p className={styles.yearContainer}>{item?.startDate} - {displayEndDate}</p>
                                        {item?.isCurrent && (
                                            <span className={styles.currentBadge}>
                                                {t('forms.workExperience.currently_working', 'Currently working')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className={styles.locationContainer}>
                                    {item?.country &&
                                        <>
                                            <img className={styles.locationIcon} src={LocationBlue} />
                                            <Flag
                                                name={item?.country}
                                                format="png"
                                                pngSize={24}
                                                shiny={false}
                                                basePath="/vendor/flags"
                                            />
                                            <p className={`${styles.description} ${styles.educationDescription}`} >{
                                                t('general.country.' + item?.country)}
                                            </p>
                                        </>
                                    }
                                </div>
                                <p className={`${styles.description} ${styles.workExperienceDescription}`} >
                                    {item?.description !== 'null' &&
                                        item?.description
                                    }
                                </p>
                            </div>
                        </div>
                    )
                })}
        </div>
    );
}

export default WorkExperience;
